<script>
    import { useNavigate, useLocation } from 'svelte-navigator';
    import authState from './store/auth';
    import sessionState from './store/session';
    import userStore from './store/user';

    const navigate = useNavigate();
    const location = useLocation();

    let mobile;

    userStore.subscribe((value) => {
        mobile = value.mobile;
    });

    $: if (!$authState.isLoggedIn) {
        navigate('/login', {
            state: { from: $location.pathname },
            replace: true,
        });
    }

    $: if ($authState.isLoggedIn && !mobile) {
        navigate('/choose-number');
    }
</script>

{#if $authState.isLoggedIn}
    <slot />
{/if}
